import { setReplaceSvg } from './_common';
import setTemplates from './templates/user/_index'
import pageLogin from './pages/user/login/index';
import pageAccountEdit from './pages/user/account/edit';
import pageProfileEdit from './pages/user/profile/edit';
import pageProfileShow from './pages/user/profile/show';
import pageRegister from './pages/user/register/index';
import pageRegisterInput from './pages/user/register/input';
import pageRegisterEmail from './pages/user/register/email';
import pageRegisterComplete from './pages/user/register/complete';
import pagePasswordReset from './pages/user/password/reset';
import pageApply from './pages/user/apply/index';
import pageJob from './pages/user/job/index';
import pageJobShow from './pages/user/job/show';
import pageHome from './pages/user/home/index';
import pageFavorite from './pages/user/favorite/index';
import pagePlan from './pages/user/plan/index';
import { setupUserLoginRequiredModals } from './_components/parts/terms-modal';
import setupPasskeyManager from './_components/passkey/manager';

window.addEventListener('load', () => {
    setReplaceSvg();
    setTemplates();
    pageLogin();
    pageAccountEdit();
    pageRegister();
    pageRegisterInput();
    pageRegisterEmail();
    pageProfileEdit();
    pageProfileShow();
    pageRegisterComplete();
    pagePasswordReset();
    pageApply();
    pageJob();
    pageJobShow();
    pageHome();
    pageFavorite();
    pagePlan();
    setupPasskeyManager();
    // パスキーの強制登録画面では規約同意などのモーダルを出さない
    if (!document.querySelector('#page-user-passkey-setup')) {
        setupUserLoginRequiredModals();
    }
})
